export default __webpack_public_path__ + "static/media/smoke_detector.1002aeca.svg";